import { ApiService } from "./api.service";

export interface IUser {
  id: number | string;
  name: string;
  email?: string;
  roleId?: number;
  roleName?: string;
  roleDisplayName?: string;
  isActive?: boolean;
  companyName?: string;
  contactNumber?: string;
}

export const UserColumnSetting: any = {
  name: { label: "Name", visibility: true, order: 0 },
  companyName: { label: "Company", visibility: true, order: 1 },
  contactNumber: { label: "Contact Number", visibility: true, order: 2 },
  email: { label: "Email", visibility:true, order:3},
  roleId: { label: "Role Id", visibility: false, order: 4 },
  // roleName holds the raw Role.Name (e.g. "Contractor") and drives access-control
  // filtering (RESTRICTED_ROLES) elsewhere -- keep it hidden and show the
  // friendlier roleDisplayName (e.g. "Qualified Contractor Employee (QCE)") instead.
  roleName: { label: "Role Name (internal)", visibility: false, order: 5 },
  roleDisplayName: { label: "Role Name", visibility: true, order: 6 },
  status: { label: "Status", visibility: true, order: 7 },
};

export class UserService {
  get() {
    return ApiService.get("User");
  }

  getById(id: string | number) {
    return ApiService.get(`User/${id}`);
  }

  add(request: any) {
    const formData = new FormData();
    formData.append("name", request.name);
    formData.append("companyName", request.companyName || "");
    formData.append("contactNumber", request.contactNumber || "");
    formData.append("email", request.email);
    formData.append("roleId", request.role);
    formData.append("password", request.password);
    return ApiService.postDocument("User/CreateUser", formData);
  }

  update(request: any) {
    const formData = new FormData();
    formData.append("name", request.name);
    formData.append("companyName", request.companyName || "");
    formData.append("contactNumber", request.contactNumber || "");
    formData.append("email", request.email);
    formData.append("roleId", request.role);
    formData.append("password", request.password);
    return ApiService.putDocument(`User/UpdateUser/${request.id}`, formData);
  }

  delete(id: string | number) {
    return ApiService.delete(`User/${id}`);
  }
  updateStatus(id: string | number,isActive:string|boolean) {
    return ApiService.get(`User/UpdateStatus/${id}?IsActive=${isActive}`);
  } 
}
